import { useGlobals } from '@/hooks';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const getHorizontalScrollPosition = (elementId: string) => {
  const location = useLocation();
  const [positionFloatButton, setPositionFloatButton] = useState<string>('');

  useEffect(() => {
    const getPositionFloatButton = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const windowScreenWidth = window.innerWidth;
      const container = document.getElementById(elementId)?.clientWidth || 1;
      const width = windowScreenWidth / 2;
      const widthContainer = container / 2;
      const positionFloatButton = `${width + widthContainer}px`;
      setPositionFloatButton(positionFloatButton);
    };

    getPositionFloatButton();
  }, [elementId, location]);

  return positionFloatButton;
};

export const getVerticalScrollPosition = () => {
  const { scrollDirection } = useGlobals();
  const [baseBottom, setBaseBottom] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const resolveBottom = async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (cancelled) return;
      const navList = document.querySelector('.nav-list');
      const navBottom = (navList?.clientHeight ?? 0) - 1;

      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (cancelled) return;
      const selectedClientElement = document.getElementById('selected-client');
      const selectedClientBottom = selectedClientElement?.clientHeight ?? 0;
      setBaseBottom(navBottom + selectedClientBottom);
    };

    resolveBottom();
    return () => {
      cancelled = true;
    };
  }, []);

  return scrollDirection !== 'down' ? baseBottom + 10 : baseBottom;
};
